import React from "react";
import { Translate, I18n } from "react-redux-i18n";
import { FaReply } from "react-icons/fa";
import { connect } from "react-redux";

import "./styles/FaqList.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

import * as actions from "../redux/actions/faqAnswerActions";
import FaqCard from "./FaqCard";
import MiniLoader from "./MiniLoader";

class FaqListAnswer extends React.Component {
  onClickSend = async (item, answer) => {
    await this.props
      .ReplyFaq(item.Id, answer, this.props.user_id, this.props.token)
      .then(() => {
        if (this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        }
      });
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadMoreFaqAnswer(this.props.pageCount, this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { faqList } = this.props;

    if (!faqList || faqList.length === 0) {
      return (
        <div className="faq-empty">
          <FaReply className="faq-empty__icon" aria-hidden="true" />
          <p className="faq-empty__text">
            <Translate value="faq_answer_not_list" />
          </p>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="faq-list">
          {faqList.map((item) => (
            <FaqCard
              key={item.Id}
              item={item}
              showReplyForm
              onReply={(answer) => this.onClickSend(item, answer)}
            />
          ))}
        </div>
        {this.props.pageSize > 4 && (
          this.props.loadingMore ? (
            <div className="faq-load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="faq-load-more">
              <button
                type="button"
                className="faq-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          )
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    error: reducer.faqAnswer.error,
    pageCount: reducer.faqAnswer.page_count,
    loadingMore: reducer.faqAnswer.loadingMore,
    pageSize: reducer.faqAnswer.page_size,
  };
}

const mapDispatchToProps = (dispatch) => ({
  ReplyFaq: (id, answer, user_id, token) =>
    dispatch(actions.updateItem({ id, answer, user_id, token })),
  LoadMoreFaqAnswer: (page_count, user_id, token) =>
    dispatch(actions.loadListScroll({ page_count, user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FaqListAnswer);
